import { Link } from "react-router-dom";
import Button from "../components/ui/Button";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-20">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          404 - Page Not Found
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Sorry, we can&apos;t find that page.
        </p>
        <div className="mt-8">
          <Button as={Link} to="/" size="lg">
            Take me back to home page
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
